import { aFetch } from '../../../core/aFetch';
import { IDictionaries } from '../../../models/Dictionaries';

const endPoints = {
	getAll: '/api/dict/get',
};

export const getAll = async () => {
	return aFetch<IDictionaries>('GET', endPoints.getAll);
};
